// top/index.ts
import browsing from "./browsing.jpg";
import editor from "./editor.jpg";
import fvzo from "./FVZO.png";
import mindmap from "./mindmap.png";
import woman from "./woman.jpg";
import whatIs from "./what_is.jpg";
import promptTemplate from "./prompt-template.jpg";
import astronaut from "./astronaut.png";

// 会社ロゴ画像
import companyOpenAI from "./companies/openai.png";
import companyGoogle from "./companies/google.png";
import companyAnthropic from "./companies/anthropic.png";
import companyAws from "./companies/aws.png";
import companyBfl from "./companies/bfl.png";
import companyIdeogram from "./companies/ideogram.png";
import companyStabilityAi from "./companies/stability_ai.png";
import companyStripe from "./companies/stripe.png";

const Top = {
  browsing,
  editor,
  fvzo,
  mindmap,
  woman,
  whatIs,
  promptTemplate,
  astronaut,
  companies: {
    openai: companyOpenAI,
    google: companyGoogle,
    anthropic: companyAnthropic,
    aws: companyAws,
    bfl: companyBfl,
    ideogram: companyIdeogram,
    stability_ai: companyStabilityAi,
    stripe: companyStripe,
  },
};

export default Top;

// 個別エクスポート
export {
  browsing as topBrowsing,
  editor as topEditor,
  fvzo as topFVZO,
  mindmap as topMindmap,
  woman as topWoman,
  whatIs as topWhatIs,
  promptTemplate as topPromptTemplate,
  astronaut as topAstronaut,
  companyOpenAI,
  companyGoogle,
  companyAnthropic,
  companyAws,
  companyBfl,
  companyIdeogram,
  companyStabilityAi,
  companyStripe,
};
